export default {
    mapGeofenceVisibleTags_success: "Preferences saved successfully",
    mapGeofenceVisibleTags_selectAll: "Select All",
    mapGeofenceVisibleTags_unselectAll: "Un-select All",
};